import React, { useEffect } from "react";
import styled from "@emotion/styled";
import { GetServerSidePropsContext } from "next";
import SignInForm from "@components/signin-form";
import Head from "next/head";
import { useTranslations } from "next-intl";
import { useRouter } from "next/router";
import { useAppSelector } from "custom-hooks/redux.hooks";
import { CPagesPath } from "shared/models/const/pages-path";
import { en, es } from "@lang";
import Layout from "@components/layout";

export async function getServerSideProps({
  locale,
}: GetServerSidePropsContext) {
  return {
    props: {
      messages: locale === "es" ? es : en,
    },
  };
}

export default function LoginPage(props: any) {
  const titleT = useTranslations("title-pages");
  const router = useRouter();
  const user = useAppSelector((state) => state.Auth.user);

  function redirectHome() {
    router.push(CPagesPath.es.home);
  }

  useEffect(() => {
    if (user) router.push(CPagesPath.es.profile);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user, router]);

  return (
    <Layout showFooter={true}>
      <Head>
        <title>{titleT("login")}</title>
      </Head>
      <Center>
        <Content>
          <SignInForm onLoginSuccess={redirectHome}></SignInForm>
        </Content>
      </Center>
    </Layout>
  );
}

const Center = styled.div`
  display: grid;
  place-content: center;
  height: var(--main-height);
`;

const Content = styled.div`
  background-color: white;
  max-width: 600px;
  padding: 70px 20px 20px;
  margin: 0 20px;
  border-radius: 40px;
  box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.13);
`;
